module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-movie-12-years.3def62d7.svg";